import React from 'react';
import PropTypes from 'prop-types';
import styles from './Card.module.scss';

const PADDING_MAP = {
  sm: styles.paddingSm,
  md: styles.paddingMd,
  lg: styles.paddingLg,
};

const ELEVATION_MAP = {
  sm: styles.elevationSm,
  md: styles.elevationMd,
  lg: styles.elevationLg,
};

const Card = ({ padding, elevation, children, className, as: Component, ...rest }) => {
  const classNames = [
    styles.card,
    PADDING_MAP[padding],
    ELEVATION_MAP[elevation],
    className || '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <Component className={classNames} {...rest}>
      {children}
    </Component>
  );
};

Card.propTypes = {
  padding: PropTypes.oneOf(['sm', 'md', 'lg']),
  elevation: PropTypes.oneOf(['sm', 'md', 'lg']),
  children: PropTypes.node,
  className: PropTypes.string,
  as: PropTypes.elementType,
};

Card.defaultProps = {
  padding: 'md',
  elevation: 'sm',
  children: null,
  className: '',
  as: 'div',
};

export default Card;
